export const breadcrumb = {
  title: 'Call tracking',

  number: {
    index: 'List of numbers'
  },

  integration: {
    index: 'Integration'
  }
};
